import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { Box } from '@mui/material'
import ConfigAPI from '../../apis/configuration/configAPI'
import MoovyQueryHandler from '../../components/moovyQueryHandler'
import { ConfigDTO } from '../../apis/configuration/dto'
import HomePage from '../homePage'
import { setClientTimeout } from '../../apis/moovyAxiosClient'
import { useParams } from 'react-router'
import ConfigurationError from './ConfigurationError'

// 15 minutes
const CONFIGURATION_POLLING_TIME = 15 * 60 * 1000

const DevicePage = () => {
  const { guid } = useParams()
  const queryClient = useQueryClient()

  const queryConfig = useQuery<ConfigDTO>({
    queryKey: ['getConfig', guid],
    queryFn: () => ConfigAPI.getConfig(guid),
    refetchInterval: CONFIGURATION_POLLING_TIME,
    staleTime: CONFIGURATION_POLLING_TIME
  })

  const timeout = queryConfig.data?.apiSettings?.timeout
  useEffect(() => {
    if (timeout) {
      setClientTimeout(timeout)
    }
  }, [timeout])

  if (queryConfig.isError) {
    return (
      <ConfigurationError
        onRetry={() =>
          queryClient.invalidateQueries({ queryKey: ['getConfig', guid] })
        }
        isLoading={queryConfig.isFetching}
      />
    )
  }

  return (
    <Box
      sx={{
        marginTop: 10
      }}
    >
      <MoovyQueryHandler query={queryConfig} rootPageIfNotFoundError>
        {queryConfig.isSuccess && <HomePage configuration={queryConfig.data} />}
      </MoovyQueryHandler>
    </Box>
  )
}

export default DevicePage
